/**
 * Single PocketBase client instance.
 *
 * Imported by lib/auth, lib/files, lib/realtime, and every page module's
 * apis/api.ts. Never instantiate PocketBase elsewhere.
 *
 * The auth store is shared with Keystone's `lib/auth/index.ts` —
 * pb.authStore.token + pb.authStore.record drive the rest of the app.
 */

import PocketBase from "pocketbase";

// API origin for the global client — the Django backend (PocketBase
// was fully removed in v2.1). The `pocketbase` npm SDK is reused purely
// as a generic REST/auth client against Django's PB-compatible API.
const API_BASE =
  (import.meta.env.VITE_API_BASE as string) || "http://127.0.0.1:8000";

export const pb = new PocketBase(API_BASE);

// Disable auto-cancellation globally so React StrictMode double-renders
// (and our deliberate parallel fetches) don't cancel each other.
pb.autoCancellation(false);

export default pb;
